import { Loading2, SearchLoop } from 'assets/icons';
import Button from 'components/button';
import Divider from 'components/divider/divider';
import EmptyState from 'components/EmptyState/EmptyState';
import ModalBody from 'components/modal/components/body';
import ModalFooter from 'components/modal/components/footer';
import Modalheader from 'components/modal/components/header';
import useModal from 'components/modal/useModal';
import Pagination from 'components/pagination/pagination';
import StyledInput from 'components/styledInput/StyledInput';
import Fuse from 'fuse.js';
import UseContext from 'hooks/useContext';
import { useEffect, useState } from 'react';
import removeAccents from 'remove-accents';
import ApiDataBase from 'server';

const kanbanColumns = [
  { name: 'wish', title: 'Souhait', icon: '🧞' },
  { name: 'test', title: 'Test', icon: '⏳' },
  { name: 'valid', title: 'Validé', icon: '✅' },
];

const ModalAddMissionVivier = () => {
  const { toggle } = useModal();
  const { dataCreateMission, setDataCreateMission } = UseContext();

  const [selectedColumn, setSelectedColumn] = useState(
    dataCreateMission.vivierStatus && dataCreateMission.vivierStatus.length > 0
      ? dataCreateMission.vivierStatus
      : ['wish', 'test', 'valid']
  );
  const [checkedIds, setCheckedIds] = useState(
    dataCreateMission.vivierSelections || []
  );
  const [listAddVivierMission, setListAddVivierMission] = useState([]);
  const [listAddVivierMissionToDisplay, setListAddVivierMissionToDisplay] =
    useState([]);
  const [search, setSearch] = useState('');
  const [totalUsersAvailable, setTotalUsersAvailable] = useState([]);
  const [searchVivierWaiting, setSearchVivierWaiting] = useState(false);
  const [countTotal, setCountTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limitElement, setLimitElement] = useState(20);

  const token = localStorage.getItem('xsrfToken');

  const fetchViviers = () => {
    setSearchVivierWaiting(true);
    ApiDataBase.postViviersMission(
      {
        token,
        vivierStatus: selectedColumn,
        title: dataCreateMission.title,
        location: dataCreateMission.location,
        dateStart: dataCreateMission.dateStart,
        dateEnd: dataCreateMission.dateEnd,
      },
      (res) => {
        const viviersWithChecked = (res.viviers || []).map((v) => ({
          ...v,
          // The API ticks the vivier that carries the mission's job title, and
          // puts it first. That answer only stands until the admin picks.
          checked:
            checkedIds.length > 0 ? checkedIds.includes(v._id) : !!v.checked,
        }));
        setListAddVivierMission(viviersWithChecked);
        setSearchVivierWaiting(false);
      },
      () => setSearchVivierWaiting(false)
    );
  };

  useEffect(() => {
    fetchViviers();
  }, [selectedColumn]);

  useEffect(() => {
    if (listAddVivierMission) {
      let totalUsers = [];
      listAddVivierMission.forEach((v) => {
        if (v.checked) totalUsers.push(...v.users_available);
      });
      setTotalUsersAvailable(Array.from(new Set(totalUsers)));
    }
  }, [listAddVivierMission]);

  useEffect(() => {
    if (listAddVivierMission.length > 0) {
      setSearchVivierWaiting(true);
      let results = listAddVivierMission;
      if (removeAccents(search.toLowerCase()) !== '') {
        const terms = search
          .split(' ')
          .map((t) => removeAccents(t.toLowerCase()));
        const options = {
          keys: ['name'],
          includeScore: true,
          threshold: 0.3,
          distance: 100,
          shouldSort: true,
          getFn: (obj, path) => {
            const val = Fuse.config.getFn(obj, path);
            return val == null
              ? ''
              : removeAccents(val.toString().toLowerCase());
          },
        };
        const fuse = new Fuse(listAddVivierMission, options);
        const combined = {};
        terms.forEach((term) => {
          fuse.search(term).forEach(({ item, score }) => {
            if (combined[item._id]) combined[item._id].score -= score;
            else combined[item._id] = { item, score };
          });
        });
        results = Object.values(combined)
          .sort((a, b) => a.score - b.score)
          .map((r) => r.item);
      }
      setCountTotal(results.length);
      setTotalPages(Math.ceil(results.length / limitElement));
      const start = (currentPage - 1) * limitElement;
      setListAddVivierMissionToDisplay(
        results.slice(start, start + limitElement)
      );
      setSearchVivierWaiting(false);
    }
  }, [search, listAddVivierMission, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedColumn, search]);

  const toggleCheck = (id) => {
    const next = listAddVivierMission.map((item) =>
      item._id === id ? { ...item, checked: !item.checked } : item
    );
    setListAddVivierMission(next);
    // Kept aside so a change of column does not drop what was ticked.
    setCheckedIds(next.filter((item) => item.checked).map((item) => item._id));
  };

  const handleConfirm = () => {
    setDataCreateMission({
      ...dataCreateMission,
      vivierSelections: listAddVivierMission
        .filter((v) => v.checked)
        .map((v) => ({ _id: v._id, name: v.name })),
      vivierStatus: selectedColumn,
      inviteType: 'vivier',
      globalNotificationRequested: false,
    });
    toggle('cM_addMissionVivier');
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Notifier la mission
      </Modalheader>
      <ModalBody>
        <div className={'flex flex-col gap-8 text-sm'}>
          <div className={'flex flex-col gap-4'}>
            <div className={'text-sm'}>1. Sélectionner l'audience</div>
            <div className={'flex gap-4'}>
              {kanbanColumns.map((kanbanColumn, index) => (
                <div
                  key={index}
                  className={`rounded p-3 w-full h-full cursor-pointer border ${
                    selectedColumn.includes(kanbanColumn.name)
                      ? 'border-yellow-500 bg-yellow-50'
                      : 'border-gray-100 bg-gray-100'
                  }`}
                  onClick={() => {
                    if (selectedColumn.includes(kanbanColumn.name)) {
                      setSelectedColumn(
                        selectedColumn.filter(
                          (item) => item !== kanbanColumn.name
                        )
                      );
                    } else {
                      setSelectedColumn([...selectedColumn, kanbanColumn.name]);
                    }
                  }}
                >
                  <div className={'flex justify-between items-center gap-1'}>
                    <div className={'flex gap-2'}>
                      <div className={'my-auto text-xl'}>
                        {kanbanColumn.icon}
                      </div>
                      <div className={'my-auto'}>{kanbanColumn.title}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Divider />
          <div className={'flex flex-col gap-4'}>
            <div className={'text-sm'}>2. Sélectionner les viviers</div>
            <div className="flex flex-col w-full gap-4">
              <div className="flex items-center gap-x-4">
                <StyledInput
                  type="text"
                  label={<span className="sr-only">Recherche...</span>}
                  name="search"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  placeholder="Recherche..."
                  imgFront={<SearchLoop wh={18} color={'#666666'} />}
                />
              </div>
              {searchVivierWaiting ? (
                <div
                  className={`flex flex-col gap-10 justify-center items-center h-40`}
                >
                  <div className={'animate-spin'}>
                    <Loading2 wh={60} color={'#FF9600'} />
                  </div>
                </div>
              ) : (
                <>
                  {listAddVivierMissionToDisplay?.length > 0 &&
                  selectedColumn.length > 0 ? (
                    <>
                      <div className="overflow-auto">
                        {!searchVivierWaiting &&
                          listAddVivierMissionToDisplay?.length > 0 &&
                          listAddVivierMissionToDisplay?.map((vivier, key) => (
                            <div className="flex flex-col py-2" key={key}>
                              <div
                                className={
                                  'py-2 flex items-center justify-between cursor-pointer'
                                }
                              >
                                <label className="flex items-center gap-2 cursor-pointer">
                                  <input
                                    type="checkbox"
                                    className={'checkbox-primary my-auto'}
                                    checked={vivier.checked}
                                    onChange={() => {
                                      toggleCheck(vivier._id);
                                    }}
                                  />
                                  <div className="flex flex-col pl-4">
                                    {vivier.name}
                                  </div>
                                </label>
                              </div>
                            </div>
                          ))}
                      </div>
                    </>
                  ) : (
                    <EmptyState type={'mission_search'} />
                  )}
                </>
              )}
            </div>
            {currentPage && totalPages > 1 && setCurrentPage ? (
              <div className={''}>
                <Pagination
                  currentPage={currentPage}
                  countPerPage={limitElement}
                  countTotal={countTotal}
                  totalPages={totalPages}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            ) : null}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className={'flex w-full justify-between items-center'}>
          <div className="flex gap-2 items-center text-sm">
            {listAddVivierMission.length > 0 && (
              <>
                <div />
                <div>
                  {totalUsersAvailable.length > 1
                    ? `${totalUsersAvailable.length} profils disponibles`
                    : `${totalUsersAvailable.length} profil disponible`}
                </div>
              </>
            )}
          </div>
          <div className={'flex gap-2'}>
            <Button onClick={toggle} size={'LG'} color={'SECONDARY'}>
              Annuler
            </Button>
            <Button onClick={handleConfirm} size={'LG'}>
              Confirmer
            </Button>
          </div>
        </div>
      </ModalFooter>
    </>
  );
};

export default ModalAddMissionVivier;
